<su-headline h="h1" skin="primary">{{ headline }}</su-headline>

<su-slot-tabs [tabs]="tabs" [activeTab]="activeTab"></su-slot-tabs>

<su-slot-tab-content *ngIf="activeTab === tabs[0].id">
  <div class="row-chips">
    <su-chip [items]="chips" (onRemove)="handleOnRemoveChip($event)"></su-chip>
  </div>
  <mtx-grid
    id="users"
    [columns]="columnsUsers"
    [data]="userData | async"
    [loading]="loadingData"
    [rowStriped]="true"
    [showPaginator]="true"
    [cellSelectable]="false"
    [showToolbar]="true"
    [showColumnMenuButton]="true"
    columnMenuButtonType="flat"
    [columnMenuButtonText]="'grid.columns_shown' | translate"
    [toolbarTemplate]="toolbarTpl"
    (rowClick)="navigateToDetails($event.rowData)">
  </mtx-grid>
</su-slot-tab-content>

<!--
  Rolle, Gültig von und Gültig bis teilen sich pro Benutzer dieselbe Zeilenliste
  (row.roleRows). Durch die feste Höhe je Eintrag bleiben die drei Spalten
  zeilenweise auf gleicher Höhe, waehrend die uebrigen Benutzerdaten einmalig
  ueber die gesamte Zeile stehen. Abgelaufene Rollen werden rot dargestellt.
-->
<ng-template #roleNamesTemplate let-row>
  <div class="role-lines">
    <span
      class="role-lines__item"
      [class.role-lines__item--expired]="roleRow.isExpired"
      *ngFor="let roleRow of row.roleRows">
      <span class="chip" [title]="roleRow.description">
        {{ roleRow.description }}
      </span>
    </span>
  </div>
</ng-template>

<ng-template #roleValidFromTemplate let-row>
  <div class="role-lines">
    <span
      class="role-lines__item"
      [class.role-lines__item--expired]="roleRow.isExpired"
      *ngFor="let roleRow of row.roleRows">
      {{ roleRow.validFrom }}
    </span>
  </div>
</ng-template>

<ng-template #roleValidUntilTemplate let-row>
  <div class="role-lines">
    <span
      class="role-lines__item"
      [class.role-lines__item--expired]="roleRow.isExpired"
      *ngFor="let roleRow of row.roleRows">
      {{ roleRow.validUntil }}
    </span>
  </div>
</ng-template>

<!--
  Verlaengern und Beenden beziehen sich auf eine einzelne Rollenvergabe und
  stehen deshalb ebenfalls je Rollenzeile. stopPropagation verhindert, dass der
  Klick zusaetzlich die Detailansicht der Zeile oeffnet.
-->
<ng-template #roleExtendTemplate let-row>
  <div class="role-lines">
    <span class="role-lines__item" *ngFor="let roleRow of row.roleRows">
      <su-button
        *ngIf="roleRow.isExtendable"
        skin="primary"
        icon="check"
        [matTooltip]="'administration.users.extend' | translate"
        [ariaLabel]="'administration.users.extend' | translate"
        (click)="$event.stopPropagation(); openExtendRoleDialog(row, roleRow)">
      </su-button>
    </span>
  </div>
</ng-template>

<ng-template #roleEndTemplate let-row>
  <div class="role-lines">
    <span class="role-lines__item" *ngFor="let roleRow of row.roleRows">
      <su-button
        *ngIf="!roleRow.isExpired"
        skin="secondary"
        icon="x"
        [matTooltip]="'administration.users.end' | translate"
        [ariaLabel]="'administration.users.end' | translate"
        (click)="$event.stopPropagation(); openEndRoleDialog(row, roleRow)">
      </su-button>
    </span>
  </div>
</ng-template>

<ng-template #toolbarTpl>
  <su-slot-controls
    [mainTLabel]="'crud.filter' | translate"
    [buttons]="controlButtons"
    [chips]="chips"
    [menuItems]="menuItems"
    [dialogData]="dialogData"
    [modal]="modalComponent"></su-slot-controls>
</ng-template>

<su-slot-tab-content *ngIf="activeTab === tabs[1].id">
  <su-card [card]="cardUser">
    <div card-content>
      <formly-form [form]="form" [fields]="formFields" [model]="formModel">
      </formly-form>
    </div>
  </su-card>
</su-slot-tab-content>

<app-spinner-overlay [show]="loading"></app-spinner-overlay>
